/** Small line icons for the message toolbar (no emoji in the interface itself). */
const base = { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round" as const, strokeLinejoin: "round" as const, "aria-hidden": true };

export const IconReact = () => (
  <svg {...base}>
    <path d="M20 12a8 8 0 1 1-6.5-7.86" />
    <path d="M8.5 14.5a4 4 0 0 0 7 0" />
    <path d="M9 9.5h.01M15 9.5h.01" />
    <path d="M19 2v6M16 5h6" />
  </svg>
);
export const IconCopy = () => (
  <svg {...base}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V6a2 2 0 0 1 2-2h9" />
  </svg>
);
export const IconCheck = () => (
  <svg {...base}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);
export const IconQuote = () => (
  <svg {...base}>
    <path d="M9 7H6a2 2 0 0 0-2 2v3h5V7ZM9 12c0 3-1.5 4.5-4 5M20 7h-3a2 2 0 0 0-2 2v3h5V7ZM20 12c0 3-1.5 4.5-4 5" />
  </svg>
);
export const IconMore = () => (
  <svg {...base}>
    <path d="M6 12h.01M12 12h.01M18 12h.01" strokeWidth={3} />
  </svg>
);

/** The agent mark next to an agent's name (like Kylon's), never an emoji. */
export const IconRobot = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" role="img" aria-label="agent">
    <rect x="4" y="8" width="16" height="11" rx="3" />
    <path d="M12 4v4M9 13h.01M15 13h.01M9.5 16.5h5M2 12v3M22 12v3" />
  </svg>
);
export const IconMail = () => (
  <svg {...base} width={16} height={16}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);
export const IconChevron = () => (
  <svg {...base} width={16} height={16}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);
export const IconClip = () => (
  <svg {...base}>
    <path d="M20.5 11.5l-8.2 8.2a5 5 0 0 1-7.1-7.1l8.6-8.6a3.4 3.4 0 0 1 4.8 4.8l-8.6 8.6a1.7 1.7 0 0 1-2.4-2.4l7.9-7.9" />
  </svg>
);
export const IconDoc = () => (
  <svg {...base}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" />
    <path d="M14 3v5h5M9 13h6M9 17h6" />
  </svg>
);
